export default __webpack_public_path__ + "static/char-29-anr-42ab35c69210a09d7ae687ccab7179c8.gif";